import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Link, RouteComponentProps} from 'react-router-dom';
import {Button, Table} from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {hasAnyPermission} from 'app/shared/auth/permissions';
import {IRootState} from 'app/shared/reducers';
import {getEntities} from './region-description.reducer';
import {IRegion} from "app/shared/model/region.model";
import {getAllByType as getCountries} from "app/entities/region/region.reducer";
import 'react-treelist/build/css/index.css';
import {AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation';

export interface IRegionDescriptionProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {
}

export const RegionDescription = (props: IRegionDescriptionProps) => {
  const {regionDescriptionList, match, loading, userCountryId} = props;
  const [activeCountry, setActiveCountry] = useState<IRegion>({})

  useEffect(() => {
    props.getCountries();
  }, []);

  useEffect(() => {
    const ac = props.countries.find(country => country.id === userCountryId)
    setActiveCountry(ac)
    props.getEntities(userCountryId);
  }, [props.countries, userCountryId]);

  const onCountryChange = (event) => {
    const countryId = event.target.value
    const newActiveCountry = props.countries.find(country => country.id === countryId)
    setActiveCountry(newActiveCountry)
    props.getEntities(countryId);
  }

  const regCountriesList = props.countries.filter((ele) => {
    return props.isAdmin ? 1 : ele.id === activeCountry?.id;
  })

  return (
    <div>
      <h2 id="regionDescription-heading">
        Region Description
      </h2>
      <br/>
      {(regCountriesList && regCountriesList.length > 0) && (<AvForm>
          <AvGroup>
            <AvInput id="region-description-country" type="select" className="form-control"
                     name="region-description-country" value={activeCountry?.id} onChange={onCountryChange}>
              {regCountriesList
                ? regCountriesList.map(country => (
                  <option value={country.id} key={country.id}>
                    {country.name}
                  </option>
                ))
                : null}
            </AvInput>
          </AvGroup>
        </AvForm>
      )}
      <div className="table-responsive">
        {regionDescriptionList && regionDescriptionList.length > 0 ? (
          <Table responsive>
            <thead>
            <tr>
              <th>Id</th>
              <th>Region Type</th>
              <th>Description (English)</th>
              <th>Description (Local Language)</th>
            </tr>
            </thead>
            <tbody>
            {regionDescriptionList.map((regionDescription, i) => (
              <tr key={`entity-${i}`}>
                <td>{regionDescription.id}</td>
                <td>{regionDescription.regionType}</td>
                <td>{regionDescription.enDesc}</td>
                <td>{regionDescription.stDesc}</td>
                <td className="text-right">
                  <div className="btn-group flex-btn-group-container">
                    <Button tag={Link} to={`${match.url}/${regionDescription.id}/edit`} color="primary" size="sm">
                      <FontAwesomeIcon icon="pencil-alt"/> <span className="d-none d-md-inline">View/Edit</span>
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
            </tbody>
          </Table>
        ) : (
          !loading && <div className="alert alert-warning">No Region Description Found</div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({regionDescription, authentication, region}: IRootState) => ({
  regionDescriptionList: regionDescription.entities,
  loading: regionDescription.loading,
  countries: region.countries,
  userCountryId: authentication.userCountryId,
  isAdmin: hasAnyPermission(authentication.account.roles, ['ADMIN'])
});

const mapDispatchToProps = {
  getEntities,
  getCountries
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(RegionDescription);
